import { useMemo } from 'react';
import { useCreativeImagesQuery, ImageTypeEnum, useArticleGroupImagesQuery } from 'api';
import { useGoogleAssetsBuilderStore } from 'stores/GoogleAssets/GoogleAssetsBuilderStore';

export const useApi = () => {
  const IMAGES_PER_PAGE = 50;
  const { article } = useGoogleAssetsBuilderStore();

  const articleGroupId = article?.articleGroup?.id;

  if (!articleGroupId) throw new Error('No article group associated with this article');

  const { data: creativeImagesData, loading: creativeImagesLoading } = useCreativeImagesQuery({
    articleGroupId: articleGroupId.toString(),
    imagesPerPage: IMAGES_PER_PAGE
  });

  const { data: articleImagesData, loading: articleImagesLoading } = useArticleGroupImagesQuery({
    id: articleGroupId.toString()
  });

  const creativeImages = useMemo(() => {
    if (!creativeImagesData || !creativeImagesData.creativeImages.edges) return [];

    return creativeImagesData.creativeImages.edges.map((edge) => ({
      id: edge!.node!.id!,
      url: edge!.node!.url!,
      type: ImageTypeEnum.CreativeImage
    }));
  }, [creativeImagesData]);

  const articleImages = useMemo(() => {
    if (!articleImagesData || !articleImagesData.articleGroup?.ogImages) return [];

    return articleImagesData.articleGroup.ogImages.map((image) => ({
      id: image.id!,
      url: image.url!,
      type: ImageTypeEnum.ArticleImage
    }));
  }, [articleImagesData]);

  return { creativeImages, articleImages, loading: creativeImagesLoading || articleImagesLoading };
};
